import React, { useEffect, useState, useCallback } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import $ from 'jquery';

export const ApexHelpArticles = (props) => {
  const [showHelpArticleTitle, setShowHelpArticleTitle] = useState(false);

  const {
    suggestionData,
    renderSuggestionToHtml,
    logger,
  } = props;

  useEffect(() => {
    if (_.get($('.apex-topic'), 'length') > 0) {
      setShowHelpArticleTitle(true);
    } else {
      setShowHelpArticleTitle(false);
    }
  }, [suggestionData]);


  const tryRenderSuggestionToHtml = useCallback((sug) => {
    try {
      return renderSuggestionToHtml(sug);
    } catch (e) {
      logger.error(`renderSuggestionToHtml Error:${e}`);
      return '';
    }
  }, [logger, renderSuggestionToHtml]);


  return (
    <React.Fragment>
      {showHelpArticleTitle ? <h6 style={{ marginLeft: '16px' }}>Help Articles</h6> : null}
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: tryRenderSuggestionToHtml(suggestionData) }}
      />
    </React.Fragment>
  );
};

ApexHelpArticles.propTypes = {
  suggestionData: PropTypes.arrayOf(PropTypes.shape({
    suggestion: PropTypes.string,
    url: PropTypes.string,
    video: PropTypes.string,
    nav: PropTypes.string,
    project: PropTypes.string,
    language: PropTypes.string,
  })),
  renderSuggestionToHtml: PropTypes.func.isRequired,
  logger: PropTypes.shape({ error: PropTypes.func.isRequired, trace: PropTypes.func.isRequired }).isRequired,
};

ApexHelpArticles.defaultProps = {
  suggestionData: undefined,
};

